
import 'slick-carousel'
import $ from 'jquery'

class ProductImageSlider {
    constructor (theme, elem) {
        this._elem = elem
        this._slider = null
        this._thumbnailWrapper = null
        this._countdown = 500
    }

    onInit () {
        this._slider = $(this._elem).slick()
        window.addEventListener('resize', () => { this.onResize() })
        window._productSlider = this._slider

        let thumbs = document.querySelectorAll('.product-single .product-single__thumbnail')
        if (thumbs.length > 0) {
            for (let i = 0; i < thumbs.length; i++) {
                thumbs[i].addEventListener('click', (e) => { this.onThumbClick(e, i) })
            }
        }
        // this.waitForArrows()
    }
    waitForArrows () {
        var slickNext = null
        var slickPrev = null
        this._thumbnailWrapper = document.querySelector('.thumbnails-wrapper')
        if (this._thumbnailWrapper) {
            slickNext = this._thumbnailWrapper.querySelector('.thumbnails-slider__next')
            slickPrev = this._thumbnailWrapper.querySelector('.thumbnails-slider__prev')
        }
        var self = this
        if (slickNext && slickPrev) {
            slickNext.addEventListener('click', () => { this._slider.slick('slickNext') })
            slickPrev.addEventListener('click', () => { this._slider.slick('slickPrev') })
        } else {
            if (this._countdown > 0) {
                this._countdown--
                console.log(this._countdown)
                requestAnimationFrame(function () { self.waitForArrows() })
            }
        }
    }
    onResize () {
        // Reslick
        if (window.innerWidth < 768) {
            if (!this._elem.classList.contains('slick-initialized')) {
                $(this._elem).slick()
            }
        }
    }
    onThumbClick (e, i) {
        e.preventDefault()
        this._slider.slick('slickGoTo', i)
    }
}

export default ProductImageSlider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductImageSlider.js